const startedNotJoined = ref([])

const loadStartedNotJoined = async (smartFileId: number, params: object) => {
  const { error, data } = await fetchStartedNotJoined(smartFileId, params)
  if (!error.value) {
    startedNotJoined.value = (data.value as any).lessons
  }
}

const fetchStarted = async () => await useAuthFetch("v2/eklase/student/lessons/started")

const fetchStartedNotJoined = async (smartFileId: number, params: object) =>
  await useAuthFetch(`v1/eklase/student/lessons/smart_file/${smartFileId}`, { params })

const fetchLastEndedLesson = async (params: { smartFileId: number; subjectId: number; gradeId: number }) =>
  await useAuthFetch("v2/eklase/student/lessons/last_ended_lesson", { params })

const joinLesson = async (lessonId: number) => await useAuthFetch(`v2/eklase/student/lessons/${lessonId}/join`)

const fetchPollAllowance = async (pollId: number, lessonId: number) =>
  await useAsyncAuthFetch(`v1/eklase/student/lessons/${lessonId}/polls/${pollId}/allowance`)

const fetchQuizAllowance = async (quizId: number, lessonId: number) =>
  await useAsyncAuthFetch(`v1/eklase/student/lessons/${lessonId}/quizzes/${quizId}/allowance`)

export const useEklaseStudentLessons = () => ({
  fetchStarted,
  fetchStartedNotJoined,
  fetchLastEndedLesson,
  loadStartedNotJoined,
  startedNotJoined,
  joinLesson,
  fetchPollAllowance,
  fetchQuizAllowance,
})
